<template>
  <table class="table table-sm text-center">
    <thead>
    <tr>
      <th>{{ $t('Auto Bid') }}</th>
      <th>{{ $t('Amount') }}</th>
      <th>{{ $t('Time') }}</th>
      <th>{{ $t('Bidder') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="bid of bids" :key="`simple-bids-table-row-${bid.uuid}`">
      <td class="text-center" v-if="bid.type === 'auto'">
        <font-awesome-icon class="text-success"  icon="check-circle"/>
      </td>
      <td class="text-center" v-if="bid.type !== 'auto'">
      </td>
      <td>{{ bid.amount | asCurrency(currency) }}</td>
      <td>{{ bid.date | toDateTime }}</td>
      <td>{{ bid.bidder.paddle_number }} {{ bid.bidder.customer.display_name }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
  import bidsService from "../../bids/BidsService";

  export default {
    name: "SimpleBidsTable",
    props: ['lotUuid', 'currency'],
    data() {
      return {
         bids: []
      }
    },
    async mounted(){
       let response = await bidsService.getBids({lot_uuid : this.lotUuid , expand: 'bidder.customer', ordering: '-latest_bid'})
       if (response.success){
         this.bids = response.body.results
       }
    }
  }
</script>

<style scoped>

</style>